import React from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const ContactPage = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const formSection = (
    <Box flex={1} display="flex" flexDirection="column">
      <Box bgcolor="#76959c" p={2} borderRadius={2} textAlign="center">
        <Typography variant="h5" color="white">
          {t("contact_title.tit")}
        </Typography>
      </Box>

      <Box
        component="form"
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        onSubmit={(e) => {
          e.preventDefault();
          alert("Mesajınız iletildi! Teşekkür ederiz.");
        }}
      >
        <TextField label={t("form.name")} variant="outlined" required />
        <TextField label={t("form.surname")} variant="outlined" required />
        <TextField
          label={t("form.email")}
          type="email"
          variant="outlined"
          required
        />
        <TextField
          label={t("form.message")}
          variant="outlined"
          multiline
          rows={4}
          required
        />
        <Button type="submit" variant="contained" color="primary">
          {t("form.send")}
        </Button>
      </Box>
    </Box>
  );

  const mapSection = (
    <Box flex={1}>
      <iframe
        width="100%"
        height="400"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=%C3%9Cniversiteler%20Mahallesi%20Hacettepe%20Teknokent%206.Arge%20C%20blok+(Mastersoft%20Ltd.%20%C5%9Eti.)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        title="Hacettepe Teknokent Map"
        style={{ borderRadius: 8 }}
      ></iframe>
    </Box>
  );

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        gap={4}
      >
        {isMobile ? (
          <>
            {formSection}
            {mapSection}
          </>
        ) : (
          <>
            {mapSection}
            {formSection}
          </>
        )}
      </Box>
    </Container>
  );
};

export default ContactPage;
